import api from '@/utils/api'

export default {
    // the requests of the current season (without their reason), for the requests page
    getSeasonPostponements() {
        return api.get('postponements')
    },

    // the postponements of the team for the active season: allowed / used / remaining and the requests made
    getTeamPostponements(teamId) {
        return api.get(`postponements/team/${teamId}`)
    },

    // a captain asks to postpone a match: it waits for the approval of the league
    requestPostponement(data) {
        return api.post('postponements', data)
    },

    // the captain of the team withdraws a pending request (it stays in the history as cancelled)
    cancelPostponement(id, data) {
        return api.post(`postponements/${id}/cancel`, data)
    }
}
